// extracted by mini-css-extract-plugin
module.exports = {"componentsLanguageSwitcher":"styles_componentsLanguageSwitcher__2SX8h"};